import React, {Fragment} from "react";

export default function CustomToolbarAfter() {
    return <Fragment/>
}